import { Type } from 'class-transformer';
import { BaseAPBillItemRawDto } from './base-ap-bill-item-raw-dto';

export class APBillReclassRawDto {
    apBillId: number;
    workflowId: number;
    managementCompanyId: number;
    communityId: number;
    description: string;

    @Type(() => BaseAPBillItemRawDto)
    items: Array<BaseAPBillItemRawDto>;
}
